import React from 'react';

import {assert} from 'Asserts';
import {EntrySearchInputWithItems} from 'notebook/entries/EntrySearchInput';
import {MultiValueFilter, SearchContext} from 'search/SearchConstants';
import pick from 'util/pick';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';

export interface EntriesFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onEnter?: () => void;
  onRemove?: () => void;
}

export default function EntriesFilterForm(props: EntriesFilterFormProps): JSX.Element {
  assert(props.filterStyle === FilterStyle.SECONDARY, 'EntriesFilterForm only supports secondary filter');
  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);

  const entryInput = (
    <EntrySearchInputWithItems
      placeholder="Select entries"
      selectedItems={props.filter.value.map((id) => ({
        id,
      }))}
      onChange={(entrySummaries: Array<{id: string}>) => {
        props.onChangeFilter({...props.filter, value: entrySummaries.map(({id}) => id)});
      }}
      shouldAllowMultiple={true}
      context={SearchContext.LISTING}
    />
  );

  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[entryInput]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove!}
    />
  );
}
